// ** tadbirkor
const initialTadbirkorState = {}

const tadbirkor = (state = initialTadbirkorState, action) => {
  switch (action.type) {
    case "SET_TADBIRKOR_TYPES_CONTENT":
      return { ...state, ...action.val }
    default:
      return state
  }
}

export default tadbirkor
